import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-confirm-address-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './confirm-address-modal.component.html',
  styleUrl: './confirm-address-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmAddressModalComponent {
  isOpen = input<boolean>(false);
  address = input<string>('');
  street = input<string>('');
  addressLine2 = input<string>('');
  city = input<string>('');
  state = input<string>('');
  zipCode = input<string>('');
  isLoading = input<boolean>(false);

  confirm = output<void>();
  cancel = output<void>();

  protected get formattedAddress(): string {
    if (this.address()) {
      return this.address();
    }

    const parts: string[] = [];

    if (this.street()) {
      parts.push(this.street());
    }
    if (this.addressLine2()) {
      parts.push(this.addressLine2());
    }

    const cityStateZip: string[] = [];
    if (this.city()) {
      cityStateZip.push(this.city());
    }
    if (this.state()) {
      cityStateZip.push(this.state());
    }
    if (this.zipCode()) {
      cityStateZip.push(this.zipCode());
    }

    if (cityStateZip.length > 0) {
      parts.push(cityStateZip.join(', '));
    }

    return parts.join('\n');
  }

  protected onConfirm(): void {
    if (!this.isLoading()) {
      this.confirm.emit();
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }
}
